import { forkJoin, Observable } from 'rxjs';
import * as _ from 'underscore';

import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Configuration, Product } from '../../../analytics-core/interfaces/configuration.interface';
import { ConfigurationLoaderService } from '../../../analytics-core/services/configuration-loader.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-content',
	styleUrls: ['../styles/content.component.css'],
	templateUrl: '../views/content.component.html'
})
export class ContentComponent implements OnInit, AfterViewInit {
	public content: string;
	public configuration: Configuration;

	constructor(
		private http: HttpClient,
		private analyticsDataModel: AnalyticsDataModel,
		private configurationLoader: ConfigurationLoaderService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.configuration = this.analyticsDataModel.config;
	}

	ngAfterViewInit(): void {
		const config: any = this.configurationByURL;
		const url = `assets/partner-assets/${config.directoryName}/content.html`;
		const content = this.http.get(url, { responseType: 'text' });

		forkJoin([content]).subscribe(
			(responses: any[]) => {
				let html = '';
				for (const resp of responses) {
					html += resp;
				}
				this.content = this.configurationLoader.generateHTMLForWidgets(
					config.widgets,
					html,
					config.isCarousel,
					this.configuration.isNavigationCarousel,
					config.isTab,
					config.enableLeftNavWidgets
				);
				this.content = this.configurationLoader.generateHTMLForOverviewWidgets(config.overviewWidgets, this.content);
			},
			(err) => console.error(err)
		);
	}

	getDirectoryName(route: string, url: string): string {
		switch (route) {
			case 'overview':
				if (this.configuration.useDefaultHtmls) {
					return `default-${this.configuration.version.toLowerCase()}/views`;
				}
				return this.configuration.partner.directoryName + '/views';
			default:
				if (this.configuration.useDefaultHtmls) {
					return `default-${this.configuration.version.toLowerCase()}/views/${url}`;
				}
				return `${this.configuration.partner.directoryName}/views/${url}`;
		}
	}

	get configurationByURL(): string {
		const urls = this.router.url.split('/');
		const url: string = urls[urls.length - 1].split('?')[0];
		const config: any = {};
		if (url.indexOf('overview') !== -1) {
			config.partnerName = this.configuration.partner.directoryName;
			config.directoryName = this.getDirectoryName('overview', url);
			config.version = this.configuration.version;
			config.widgets = this.configuration.widgets;
			config.overviewWidgets = this.configuration.overviewWidgets;
		} else {
			config.partnerName = this.configuration.partner.directoryName;
			config.directoryName = this.getDirectoryName('', url);
			config.version = this.configuration.version;
			const product: Product = _.findWhere(this.configuration.products, { productURL: url });
			if (product) {
				config.widgets = product.widgets;
				config.isCarousel = product.isCarousel;
				config.isTab = product.isTab;
				config.enableLeftNavWidgets = product.enableLeftNavWidgets;
				config.overviewWidgets = product.overviewWidgets;
			}
		}
		return config;
	}
}
